"use client"
import React, {useState} from "react";
import { Ticker } from "@vereinsheim/backend-types/src/ticker";
import { apiCreateTickerPath, apiLinkTickerPath } from "@/utils/urlHelper";
import { useSession } from "next-auth/react";
import Button from "@/app/pwa/components/Button";
import Link from "next/link";
import ExternalLink from "@/assets/icon/external-link.svg"

export function TickerButton({ ticker, matchId, teamId }: { ticker: Ticker | undefined, matchId: number, teamId: number }) {
  const {data: session} = useSession();
  const [loading, setLoading] = useState(false);
  const [loadingTickern, setLoadingTickern] = useState(false);
  const [tickerLink, setTickerLink] = useState(null);
  const [intTicker, setIntTicker] = useState< Ticker | undefined>(ticker);
  
  async function createTicker() {
    setLoading(true)
    const body = {matchId: matchId, teamId: teamId}
    const response = await fetch(apiCreateTickerPath(), {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "POST",
      body: JSON.stringify(body)
    });
    if(response.status == 200) {
      const json = await response.json()
      setIntTicker(json)
      setLoading(false)
    }
    else {
      setLoading(false)
    }
  }

  async function linkTicker() {
    setLoadingTickern(true)
    const body = {tickerId: intTicker?.tickerId, userName: session?.user.name, userInternalId: session?.user.internalId}
    const response = await fetch(apiLinkTickerPath(), {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "POST",
      body: JSON.stringify(body)
    });
    if(response.status == 200) {
      const json = await response.json()
      setTickerLink(json.link)
      setLoadingTickern(false)
      window.open(json.link)
    }
    else {
      setLoadingTickern(false)
    }
  }



  return (
    <div className={`flex flex-col items-center`}>
      { !intTicker && 
        <>
          <Button loading={loading} onClick={() => createTicker()} color="primary" className="mt-2">
            Spielticker erstellen<ExternalLink className="ml-blank" />
          </Button>
        </>
      }
      { intTicker && !tickerLink &&
        <Button loading={loadingTickern} onClick={() => linkTicker()}>
          Spielticker bearbeiten<ExternalLink className="ml-blank" />
        </Button>
      }
      {
        tickerLink &&
        <>
          <Button disabled={true} loading={loading} color="primary" className="mt-2">
            Spielticker erstellen<ExternalLink className="ml-blank" />
          </Button>
          <Link href={tickerLink} target="_blank" className="button button--link-secondary" >
            Weiterleitung zu Spielticker
          </Link>
        </>
      }
    </div>
  );
}
